export * from './agregar-ins-a-cotiz-existente-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-detalle-insumo-page/agregar-ins-a-cotiz-existente-dialog/index.ts